import React, { useEffect } from 'react';
import { PageLoader } from '@/components/Elements/PageLoader/PageLoader';
import { routes } from '@/constants/routes';
import { useRedirectAppRouter } from '@/hooks/useRedirectAppRouter';

const LandingPage = () => {
  const router = useRedirectAppRouter();

  useEffect(() => {
    router.pushWithRedirectAppParam(routes.login);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageLoader />;
};

export default LandingPage;
